import React, { FC } from 'react';
import { INotificationOuter } from './Notification.types';

export const Notification: FC<INotificationOuter> = ({ notification, messageProps }) => {
  const { NotificationComponent } = notification;

  return <NotificationComponent {...messageProps} notification={notification} />;
};
